// extracted by mini-css-extract-plugin
export default {"helloworld":"Home_helloworld__eou05","topSeparator":"Home_topSeparator__uP2oo","bookNowA":"Home_bookNowA__zEAsC"};